/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbCodePostalGridDto } from './FcbCodePostalGridDto';
import {
    FcbCodePostalGridDtoFromJSON,
    FcbCodePostalGridDtoFromJSONTyped,
    FcbCodePostalGridDtoToJSON,
} from './FcbCodePostalGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbCodePostalGridDtoPaginatedResults
 */
export interface FcbCodePostalGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbCodePostalGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbCodePostalGridDto>}
     * @memberof FcbCodePostalGridDtoPaginatedResults
     */
    results?: Array<FcbCodePostalGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbCodePostalGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbCodePostalGridDtoPaginatedResults interface.
 */
export function instanceOfFcbCodePostalGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbCodePostalGridDtoPaginatedResultsFromJSON(json: any): FcbCodePostalGridDtoPaginatedResults {
    return FcbCodePostalGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbCodePostalGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbCodePostalGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbCodePostalGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbCodePostalGridDtoPaginatedResultsToJSON(value?: FcbCodePostalGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbCodePostalGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

